// extracted by mini-css-extract-plugin
export var DeskAside = "desk-module--DeskAside--d260e";
export var DeskContent = "desk-module--DeskContent--af4a3";
export var MainAndSideWrapper = "desk-module--MainAndSideWrapper--a8fd0";
export var deskArticlesGrid = "desk-module--desk-articles-grid--a9148";
export var intro = "desk-module--intro--8b31a";